import styled from "@emotion/styled";
import { Colors } from "theme/colors";
import { fontQuicksand } from "theme/fonts";

export const StyleValuePair = styled.div`
  margin-bottom: 1rem;
`;

export const StyledLabel = styled.span`
  display: block;
  padding: 0 1.25rem 0.25rem 0;
  color: ${Colors.BLUE};
  ${fontQuicksand()}
`;

export const StyledContent = styled.div``;
